var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoLibro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3514 4.31697C11.7704 1.97065 6.39844 1.4197 2.85418 1.43793C1.80694 1.44332 1 2.31624 1 3.36349V15.6791C1 16.908 2.10237 17.8627 3.33119 17.8441C6.14771 17.8016 10.373 18.2433 14.3514 20.1277",
    stroke: "url(#paint0_linear_1645_8924)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6486 4.31697C16.2296 1.97065 21.6016 1.4197 25.1458 1.43793C26.1931 1.44332 27 2.31624 27 3.36349V15.6791C27 16.908 25.8976 17.8627 24.6688 17.8441C21.8523 17.8016 17.627 18.2433 13.6486 20.1277",
    stroke: "url(#paint1_linear_1645_8924)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.96484V19.7757",
    stroke: "url(#paint2_linear_1645_8924)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1645_8924",
    x1: 15.1168,
    y1: 0.332658,
    x2: 8.5462,
    y2: 22.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1645_8924",
    x1: 12.8832,
    y1: 0.332658,
    x2: 19.4538,
    y2: 22.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1645_8924",
    x1: 15.0573,
    y1: 3.03021,
    x2: 9.51486,
    y2: 4.67659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoLibro);
export default __webpack_public_path__ + "static/media/icono-libro.08e2bc2d6faad86e83ab3956e01b5a10.svg";
export { ForwardRef as ReactComponent };